/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
// @ts-ignore
import * as Msdyn365 from '@msdyn365-commerce/core';
import { observer } from 'mobx-react';
import * as React from 'react';
import { INileNewsletterData } from './nile-newsletter.data';
import { INileNewsletterProps } from './nile-newsletter.props.autogenerated';
import { IModuleProps, INodeProps, Modal, ModalBody, ModalFooter, ModalHeader } from '@msdyn365-commerce-modules/utilities';

export interface INileNewsletterPreference {
    nileNewsletterPreference: INodeProps;
    buttonWrapper: INodeProps;
    buttonYesText: React.ReactNode;
    buttonNoText: React.ReactNode;
    button: React.ReactNode;
    description: React.ReactNode;
}
export interface INileNewsletterItem {
    NileNewsletterItem: INodeProps;
    links?: React.ReactNode;
    description?: React.ReactNode;
}

export interface INileNewsletterViewProps extends INileNewsletterProps<INileNewsletterData> {
    nileNewsletter: IModuleProps;
    nileNewsletterWrapper?: INodeProps;
    className: string;
    modalContainer: IModuleProps;
    modalHeaderContainer: INodeProps;
    modalFooterContainer: INodeProps;
    modalBodyContainer: INodeProps;
}
/**
 *
 * NileNewsletter component.
 * @extends {React.Component<INileNewsletterProps<INileNewsletterData>>}
 */
@observer
export class NileNewsletter extends React.PureComponent<INileNewsletterProps<INileNewsletterData>> {
    public constructor(props: INileNewsletterProps<INileNewsletterData>) {
        super(props);
    }
    public shouldComponentUpdate(nextProps: INileNewsletterProps<INileNewsletterData>): boolean {
        if (this.props.data === nextProps.data) {
            return false;
        }
        return true;
    }
    /**
     * Initiate close modal
     */
    public readonly closeModal = (): void => {
        this.setState({
            isModalOpen: false
        });
    };
    public render(): JSX.Element {
        const { config } = this.props;
        const { className } = config;
        const viewProps = {
            ...this.props,
            className,
            nileNewsletter: {
                moduleProps: this.props
            },
            modalContainer: {
                moduleProps: this.props,
                tag: Modal,
                className: 'ms-nile-newsletter__dialog',
                isOpen: true,
                'aria-label': 'nile-newsletter',
                toggle: this.closeModal,
                modalTransition: { timeout: 0 },
                shouldUpdateFocusToFirstElement: true
            },
            modalHeaderContainer: {
                tag: ModalHeader,
                className: 'ms-nile-newsletter__modal-header',
                toggle: this.closeModal
            },
            modalFooterContainer: {
                tag: ModalFooter,
                className: 'ms-nileNewsletter__modal-footer'
            },
            modalBodyContainer: {
                tag: ModalBody,
                className: 'ms-nileNewsletter__modal-body'
            }
        };
        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default NileNewsletter;
